'use client';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef } from 'react';

import { AutoComplete } from '@/components/AutoComplete/AutoComplete';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const BlogSearchInput = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const divRef = useRef<HTMLDivElement>(null);
  const firstRenderRef = useRef(true);

  const defaultSearch = searchParams.get('q') || '';

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return;
    }

    const query = defaultSearch ? `?q=${encodeURIComponent(defaultSearch)}` : '';
    router.replace(`${pathname}${query}`, {
      scroll: false,
    });
  }, [defaultSearch]);

  return (
    <div
      ref={divRef}
      className="w-full md:w-[31.25rem] rounded-full px-6 py-2 border border-[#D8D8D8] flex items-center mx-7 md:mx-0"
    >
      <AutoComplete
        placeholder="What are you looking for?"
        inverted
        classIcon="!hidden"
        searchPath={pathname}
        defaultSearch={defaultSearch}
        overrideOnEnter
        className="[&_input]:!px-3 [&_input]:!py-2 [&_input]:!border-none [&_input]:!outline-none [&_input]:!ring-0 [&_input]:md:!text-xl !flex-1 [&_input]:!shadow-none"
      />
      <FontAwesomeIcon icon={faSearch} className="size-5 text-[#667085] cursor-pointer" />
    </div>
  );
};
